module.exports = __webpack_public_path__ + "static/media/regulamentoAuto.926330f4.pdf";